<section class="profile-page" aria-label="Profile page">
  <header class="profile-header">
    <a class="back-link" routerLink="/home/settings">
      <mat-icon aria-hidden="true">arrow_back</mat-icon>
      Back to settings
    </a>
    <h1>Profile</h1>
    <p>View and update your personal account details.</p>
  </header>

  <div class="profile-layout">
    <mat-card class="profile-photo-card">
      <div class="profile-photo" [class.profile-photo--image]="photoPreview()">
        @if (photoPreview()) {
          <img [src]="photoPreview()" alt="Profile preview" />
        } @else {
          <span>{{ getProfileInitials() }}</span>
        }
      </div>

      <input #photoInput type="file" accept="image/*" (change)="onPhotoSelected($event)" hidden />
      <button type="button" mat-stroked-button color="primary" (click)="openPhotoPicker(photoInput)">
        <mat-icon aria-hidden="true">photo_camera</mat-icon>
        Edit profile photo
      </button>
      <button type="button" mat-button color="warn" (click)="removeProfilePhoto()" [disabled]="isSaving() || !canRemovePhoto()">
        <mat-icon aria-hidden="true">delete</mat-icon>
        {{ removePhotoButtonLabel() }}
      </button>
      <small>PNG, JPG up to 5MB.</small>
    </mat-card>

    <form class="profile-form" [formGroup]="profileForm" (ngSubmit)="saveProfile()" novalidate>
      <mat-form-field appearance="outline">
        <mat-label>Full name</mat-label>
        <input matInput type="text" formControlName="fullName" />
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Email</mat-label>
        <input matInput type="email" formControlName="email" />
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Phone</mat-label>
        <input matInput type="tel" formControlName="phone" />
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Timezone</mat-label>
        <mat-select formControlName="timezone">
          @for (timezone of timeZoneOptions(); track timezone) {
            <mat-option [value]="timezone">{{ timezone }}</mat-option>
          }
        </mat-select>
      </mat-form-field>

      <div class="profile-form__actions">
        <button type="button" mat-stroked-button color="primary" routerLink="/home/settings">Cancel</button>
        <button type="submit" mat-flat-button color="primary" [disabled]="isSaving()">Save changes</button>
      </div>
    </form>
  </div>
</section>
